import axios from 'axios';

export default {
	list() {
		return axios.get(`/api/agreements?include=confirmed,unconfirmed`);
	},
};
